<template>
  <svg viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.5 0.499L9 18.499 4 13.499" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M18.273,12.493A8.993,8.993,0,1,1,13.5,6.435" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
